import { useEffect, useState } from "react";

import { IFormSchema, IFormValues } from "../types/types";
import { getIndex } from "helpers";

export const useFormPages = (values: IFormValues) => {
  const [pages, setPages] = useState<IFormSchema[][]>([]);

  useEffect(() => {
    // return a new array with the elements for each page
    const getPages = () => {
      const { pagesIndex } = getIndex(values);
      const index = pagesIndex;
      const formPages = [];
      let currentIndex = 0;

      const pagination = values?.schema?.some(
        (item) => item.component.type === "page"
      );
      if (!pagination) {
        const basicForm = values?.schema?.filter(
          (item) => item.component.type !== "page"
        );
        formPages.push(basicForm);
      } else {
        for (let i = 0; i < index[index?.length - 1]; i++) {
          if (currentIndex === 0) {
            let formSection = values?.schema?.slice(currentIndex, index[0]);
            currentIndex = index[0];
            formPages.push(formSection);
            index.shift();
          }
          if (currentIndex !== 0) {
            let formSection = values?.schema?.slice(currentIndex + 1, index[0]);
            currentIndex = index[0];
            formPages.push(formSection);
            index.shift();
          }
        }
      }
      setPages(formPages);
    };
    getPages();
  }, [values]);

  return {
    pages,
  };
};
